export const Introduction = () => {
    return (
        <div className="introduction tag">
            <p className="header">Hello, my name is Henry 👋🏻</p>
            <p className="introduction_content">I am a freelance web / blockchain engineer, long distance runner and cellist based in Rochester, NY.</p>
        </div>
    )
}